import React from 'react'

import { cn } from '~/styled'

import { Text } from '../text/Text'

export const SectionMessageDescription = ({
  className,
  ...rest
}: React.ComponentProps<typeof Text>): React.JSX.Element => (
  <Text size="sm" {...rest} className={cn('text-grey-900', className)} />
)
